import { computed } from 'vue'
import { useAuthStore } from '@/stores'
import { useI18n } from 'vue-i18n'

export function useRandomWelcome() {
  const authStore = useAuthStore()
  const { t } = useI18n()
  
  // Get user name from auth store
  const userName = computed(() => authStore.user?.name?.split(' ')[0] || 'Admin')
  
  // Define welcome message keys
  const welcomeMessageKeys = [
    { messageKey: 'dashboard.admin.welcome-messages.message-1', subtitleKey: 'dashboard.admin.welcome-messages.subtitle-1' },
    { messageKey: 'dashboard.admin.welcome-messages.message-2', subtitleKey: 'dashboard.admin.welcome-messages.subtitle-2' },
    { messageKey: 'dashboard.admin.welcome-messages.message-3', subtitleKey: 'dashboard.admin.welcome-messages.subtitle-3' },
    { messageKey: 'dashboard.admin.welcome-messages.message-4', subtitleKey: 'dashboard.admin.welcome-messages.subtitle-4' },
    { messageKey: 'dashboard.admin.welcome-messages.message-5', subtitleKey: 'dashboard.admin.welcome-messages.subtitle-5' }
  ]
  
  // Randomly select a welcome message
  const selectedWelcome = computed(() => {
    const randomIndex = Math.floor(Math.random() * welcomeMessageKeys.length)
    const selected = welcomeMessageKeys[randomIndex]
    
    return {
      message: t(selected.messageKey, { name: userName.value }),
      subtitle: t(selected.subtitleKey)
    }
  })
  
  return {
    selectedWelcome
  }
} 